import React from "react";
import { graphql } from "gatsby";
import { reverseKebabCase } from "../../utilities/helper.js";
import { useCollectAnchorLinks } from "../../context/anchorLinksContextProvider.js";
import SubscriptionWidgetForm from "../form/subscriptionWidgetForm.js";
//https://github.com/t49tran/react-google-recaptcha-v3#react-hook-usegooglerecaptcha-recommended-approach

import RichTextComponent from "./richTextComponent.js";
import Icon from "../icons/icon";

const SubscriptionWidget = ({ widgetData, blockIndex = null }) => {
  const {
    id,
    anchor,
    icon,
    bodyCopy,
    // mailingList,
    // mobilePhoneMandatory,
    // buttonText,
    // buttonType,
    // privacyText,
    // successRedirect
  } = widgetData;

  const Anchor = anchor ?? id;
  useCollectAnchorLinks(reverseKebabCase(anchor), anchor, blockIndex);

  // The reasone binding interactive action to form  because the input inside the form is interactive
  return (
    <div className={`banner bg-light-yellow body subscription-widget`} id={Anchor}>
      <div className={`banner--wrapper`}>
        <div className={`banner--wrapper__content`}>
          {icon ? <Icon name={icon} /> : null}
          {bodyCopy ? <RichTextComponent data={bodyCopy} /> : ""}
        </div>
        <div className={`banner--wrapper__content banner--wrapper__content--form`}>
          <SubscriptionWidgetForm widgetData={widgetData} />
        </div>
      </div>
    </div>
  );
};

export default SubscriptionWidget;

export const query = graphql`
  fragment SubscriptionWidget on ContentfulSubscriptionWidget {
    id
    anchor
    name
    mailingList
    mobilePhoneMandatory
    icon
    buttonText
    buttonType
    successRedirect
    bodyCopy {
      ...RichTextComponent
    }
    privacyText {
      ...RichTextComponent
    }
  }
`;
